<template>
    <div>
        <b-modal
            :id="$options.name  + this.componentKey"
            :cancel-title="$t('form.cancel')"
            :ok-title="$t('search.find')"
            header-bg-variant="primary"
            size="lg"
            :title="$t('adventure.search.modal_title')"
        >
            <!--            @ok="addExperienceToAdventure(marker)"-->
            <!--            :scrollable="!getRecords > 3"-->

            <b-overlay :opacity="overlay.opacity" :show="overlay.visible" rounded="sm">
                <!-- type -->
                <b-row class="">
                    <b-col cols="12">
                        <h5>{{$t('adventure.search.type')}}:</h5>
                    </b-col>
                    <b-col cols="12">
                        <b-button
                            size="sm"
                            pill
                            variant="white"
                            class="border-primary"
                        >
                            <!--                            variant="white" --> <!--TODO onselect variant="secondary"-->
                            kolesarjenje
                        </b-button>
                    </b-col>
                </b-row>
                <!-- language -->
                <b-row class="mt-3">
                    <b-col cols="12">
                        <h5>{{$t('adventure.search.language')}}:</h5>
                    </b-col>
                    <b-col cols="12">
                        <b-button
                            size="sm"
                            pill
                            variant="white"
                            class="border-primary"
                        >
                            <!--                            variant="white" --> <!--TODO onselect variant="secondary"-->
                            slovenščina
                        </b-button>
                    </b-col>
                </b-row>
                <!-- suitable for -->
                <b-row class="mt-3">
                    <b-col cols="12">
                        <h5>{{$t('adventure.search.suitable_for')}}:</h5>
                    </b-col>
                    <b-col cols="12">
                        <b-button
                            size="sm"
                            pill
                            variant="white"
                            class="border-primary"
                        >
                            <!--                            variant="white" --> <!--TODO onselect variant="secondary"-->
                            otroci
                        </b-button>
                    </b-col>
                </b-row>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "ModalSearchAdventure",
    components: {},
    props: {
        componentKey: {
            type: String,
            default: ''
        },
        modalBus: Object,
    },
    data() {
        return {
            overlay: {
                visible: false,
                opacity: 0.7,
            },
            experienceDate: null,
            experienceGuests: null,
            guests: {
                adult: 0,
                child: 0,
                toddler: 0,
                senior: 0,
                schoolchild: 0,
                escort: 0,
                driver: 0,
            },
        }
    },
    mounted() {
        this.modalBus.$on('modalOpen', (recordId) => {
            // this.records = this.__clone(this.parentRecords);
            this.modalOpen();
        });
    },
    methods: {
        showOverlay(show) {
            this.overlay.visible = show;
        },
        resetValidity() {
            this.$set(this, 'tabValidity', this.__clone(this.validityDefault));
        },
        resetErrors() {
            this.$set(this, 'errors', this.__clone(this.errorsDefault));
        },
        // <-- modal -->
        modalOpen() {
            /*            this.resetValidity();
                        this.resetErrors();
                        // <--  -->
                        if (this.form.id > 0) {
                            this.loadEdit();
                            return;
                        }
                        this.loadNew();*/
            this.$bvModal.show(this.$options.name + this.componentKey);
        },
        modalClose() {
            this.showOverlay(false);
        },
        hideModal(data) {
            this.$emit('refresh', data);
            // <-- hide the modal manually -->
            this.$nextTick(() => {
                this.$bvModal.hide(this.$options.name + this.componentKey);
            });
        },
    },
    computed: {
        title: {
            get() {
                // let record = this.record;
                // if (this.form.id <= 0 || record === null || record.meta === undefined || record.meta.name === undefined) {
                //     return this.$t('form.add') + ': ' + this.$tc(this.localeKey, 0).toLowerCase();
                // }
                // // <-- name -->
                // let name = record.meta.name;
                // // <--  -->
                // return this.$tc(this.localeKey, 0) + ': ' + name;
                return this.$tc('adventure.season', 1);
            },
        },
    },
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
